import { render, staticRenderFns } from "./layout-draw-scenes.vue?vue&type=template&id=50fd659c&scoped=true"
import script from "./layout-draw-scenes.vue?vue&type=script&lang=js"
export * from "./layout-draw-scenes.vue?vue&type=script&lang=js"
import style0 from "./layout-draw-scenes.vue?vue&type=style&index=0&id=50fd659c&prod&lang=scss&scoped=true"
import style1 from "./layout-draw-scenes.vue?vue&type=style&index=1&id=50fd659c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd659c",
  null
  
)

export default component.exports